import { Injectable } from "@angular/core";

import { MessageEnum } from "../../core/enums/message.enum";

import { IMessage } from "../../core/interfaces/message.interface";

@Injectable({
  providedIn: "root",
})
export class MessageDataService {
  getMessageData(): IMessage[] {
    return [
      {
        captionButtom: "Reintentar",
        description:
          "¡Por favor intenta de nuevo cargar el archivo y enviar el desprendible!",
        icon: "../../../../assets/images/icon-error.svg",
        messageId: MessageEnum.ERROR_UPLOAD_FILE_TAP_SOLUTION,
        title: "Lo sentimos",
      },
    ];
  }
}
